import { render, staticRenderFns } from "./TopAgentsLeaderboard.vue?vue&type=template&id=44aaf42c&scoped=true&"
import script from "./TopAgentsLeaderboard.vue?vue&type=script&lang=js&"
export * from "./TopAgentsLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./TopAgentsLeaderboard.vue?vue&type=style&index=0&id=44aaf42c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaf42c",
  null
  
)

export default component.exports